module.exports = __webpack_public_path__ + "img/1.482dc4ad.jpg";